/**
 * Created by jacmai on 6/30/2017.
 */
define(["backbone", "messaging/messenger"], function (Backbone, Messenger) {
  var ResponsePreviewModel = {};

  /**
   * Response preview model stores information about the state of the preview window,
   * included selected touchpoints and locales
   */
  ResponsePreviewModel.responsePreview = Backbone.Model.extend({
    defaults: {
      response: "",
    },
    initialize: function () {
      //initialize with TP and locale lists and set selected items from the user's defaults
      this.set("touchPoints", Messenger.reqres.request("kb:touchpoints"));
      this.set("locales", Messenger.reqres.request("kb:languages"));
      this.set("selectedTouchPoint", Messenger.reqres.request("default:touchpoint"));
      this.set("selectedLocale", Messenger.reqres.request("default:response:language"));
    },
  });

  return ResponsePreviewModel;
});
